import React from 'react';
import { compose, withHandlers, withState, withPropsOnChange } from 'recompose';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import { Editor } from 'react-draft-wysiwyg';
import {withRouter} from 'react-router';

class WysiwygEditor extends React.Component {

  render() {
    const {
      meta: { touched, error },
      editorState,
      onEditorStateChange,
      handleBeforeInput,
      toolbar
    } = this.props;

    return (
      <div className="WysiwygEditor">
        {
          editorState &&
          <Editor
            editorState={editorState}
            onEditorStateChange={onEditorStateChange}
            handleBeforeInput={handleBeforeInput}
            editorClassName="editable-textarea"
            toolbarClassName="toolbar"
            toolbar={toolbar}
          />
        }
        {touched && error && <div className='errorstr'>{error}</div>}
      </div>
    )
  }
}
// const WysiwygEditor =
//   (
//     {
//       input: { value, onChange },
//       maxLength,
//       meta: { touched, error },
//       editorState,
//       onEditorStateChange,
//       handleBeforeInput,
//       toolbar
//     }
//   ) => (
//     <div className="WysiwygEditor">
//       {
//         editorState &&
//         <Editor
//           editorState={editorState}
//           onEditorStateChange={onEditorStateChange}
//           handleBeforeInput={handleBeforeInput}
//           editorClassName="editable-textarea"
//           toolbarClassName="toolbar"
//           toolbar={toolbar}
//         />
//       }
//       {touched && error && <div className='errorstr'>{error}</div>}
//     </div>
//   );

export default compose(
  withState("editorState", "setEditorState", EditorState.createEmpty()),
  withRouter,
  withPropsOnChange(
    ['input'],
    ({ input: { value }, meta: { pristine, dirty }, setEditorState }) => {

      if (dirty) {
        return;
      }
      if (!value) {
        return;
      }
      const contentBlock = htmlToDraft(value);
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const editorState = EditorState.createWithContent(contentState);
      setEditorState(editorState);
    }
  ),
  withHandlers({
    onEditorStateChange: ({ input: { onChange }, setEditorState }) => (editorState) => {
      setEditorState(editorState);
      const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      onChange(html);
    },
    handleBeforeInput: ({ maxLength, input: { value } }) => (chars, editorState) => {
      const totalLength = editorState.getCurrentContent().getPlainText().length + chars.length;
      const numParagraphs = (value.match(/<p>/g) || []).length;
      if(numParagraphs > 0) {
        maxLength = maxLength - (numParagraphs * 45);
      }
      return totalLength > maxLength || numParagraphs >= 4;
    }
  })
)(WysiwygEditor);



// WEBPACK FOOTER //
// ./src/common/components/Form/WysiwygEditor/index.js